/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import * as _ from 'lodash'
import { Directive, ElementRef, Input } from '@angular/core'
import { AuthService } from './auth.service'
import { PermissionService } from './permission.service'

@Directive({
    selector: '[ifAuthorized]',
})
export class AuthDirective {
    @Input() ifAuthorized = ''

    constructor(
        private element: ElementRef,
        private authService: AuthService,
        private permissionService: PermissionService
    ) {}

    ngOnInit() {
        let vm = this

        var validationResult = null
        if (vm.ifAuthorized && _.includes(vm.ifAuthorized, ':')) {
            var perm = '' + vm.ifAuthorized
            var useNot = false
            if (perm.indexOf('!') === 0) {
                useNot = true
            }
            var allow = vm.authService.authorized(perm)
            if (useNot) {
                allow = !allow
            }

            validationResult = {
                name: vm.ifAuthorized,
                enabled: allow,
                visible: allow,
            }
        } else {
            validationResult = vm.permissionService.findByActionName(vm.ifAuthorized)
        }

        // If the validation result indicates this should not be visible, hide it. Otherwise don't modify
        if (!validationResult.visible) {
            vm.element.nativeElement.style.display = 'none'
        }

        // If the validation result indicates this should not be enabled, disable it. Otherwise don't modify
        if (!validationResult.enabled) {
            vm.element.nativeElement.disabled = true
        }
    }
}
